import { render, staticRenderFns } from "./BusinessInformationTextData.vue?vue&type=template&id=314ecef5&scoped=true"
import script from "./BusinessInformationTextData.vue?vue&type=script&lang=js"
export * from "./BusinessInformationTextData.vue?vue&type=script&lang=js"
import style0 from "./BusinessInformationTextData.vue?vue&type=style&index=0&id=314ecef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314ecef5",
  null
  
)

export default component.exports